import { render } from "./SalesPersonList.vue?vue&type=template&id=21cbf4b0&scoped=true&ts=true&lang=pug"
import script from "./SalesPersonList.vue?vue&type=script&lang=ts&setup=true"
export * from "./SalesPersonList.vue?vue&type=script&lang=ts&setup=true"

import "./SalesPersonList.vue?vue&type=style&index=0&id=21cbf4b0&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21cbf4b0"]])

export default __exports__